import api from '@/http/api'
import { useQuery } from '@tanstack/react-query'

export interface OrderTag {
  id: number
  name: string
  color: string
}

const fetchOrderTags = (): Promise<OrderTag[]> =>
  api.get('/admin/order-tags').then(r => r.data.data)

export const useOrderTags = () => {
  return useQuery<OrderTag[]>({
    queryKey: ['order-tags'],
    queryFn: fetchOrderTags,
    staleTime: 5 * 60 * 1000, // 5 minutes cache
  })
}
